import Swal from "sweetalert2";
import api from "@/services/index"

export const CheckSession = {
    data() {
        return {
            UserInfo: {
                Username: "",
                Credit: 0,
                Permissions: 0
            }
        }
    },
    watch: {
        $route() {
            this.CheckPermissions();
        },
    },
    created() {
        this.CheckPermissions();
    },
    methods: {
        async CheckPermissions() {
            try {
                var v = await api.get("/session");
                if (v.status.code == 404) {
                    Swal.fire("แจ้งเตือน", v.status.message, "error");
                    this.$router.push("/login");
                } else {
                    this.UserInfo.Permissions = v.data.Level;
                    this.UserInfo.Credit = v.data.Credit;
                    this.UserInfo.Username = v.data.username;
                }
            } catch {
                this.$router.push("/login");
            }
        },
    },
}